"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './ColumnLayout.module.scss.mjs';
import { getColumns } from './lib/getColumns.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const ColumnLayout = flowComponent("ColumnLayout", (props) => {
  const {
    children,
    className,
    s,
    m,
    l,
    gap = "m",
    rowGap = gap,
    columnGap = gap,
    elementType = "div",
    "aria-label": ariaLabel,
    ref,
    mergeInParentContext
  } = props;
  let elementClassName = styles.columnLayout;
  s?.map((v, i) => {
    if (v === null) {
      elementClassName = clsx(elementClassName, styles[`hide-s-${i + 1}`]);
    }
  });
  m?.map((v, i) => {
    if (v === null) {
      elementClassName = clsx(elementClassName, styles[`hide-m-${i + 1}`]);
    }
  });
  l?.map((v, i) => {
    if (v === null) {
      elementClassName = clsx(elementClassName, styles[`hide-l-${i + 1}`]);
    }
  });
  const columnsS = s ? getColumns(s) : "1fr";
  const columnsM = m ? getColumns(m) : s ? columnsS : "1fr 1fr";
  const columnsL = l ? getColumns(l) : m || s ? columnsM : "1fr 1fr 1fr";
  const style = {
    "--column-layout--columns-s": columnsS,
    "--column-layout--columns-m": columnsM,
    "--column-layout--columns-l": columnsL,
    "--column-layout--row-gap": `var(--column-layout--gap--${rowGap})`,
    "--column-layout--column-gap": `var(--column-layout--gap--${columnGap})`
  };
  const rootClassName = clsx(styles.columnLayoutContainer, className);
  const Element = elementType;
  const propsContext = {
    Section: {
      hideSeparator: true
    }
  };
  return /* @__PURE__ */ jsx("div", { className: rootClassName, style, children: /* @__PURE__ */ jsx(
    Element,
    {
      ref,
      "aria-label": ariaLabel,
      className: elementClassName,
      children: /* @__PURE__ */ jsx(
        PropsContextProvider,
        {
          props: propsContext,
          mergeInParentContext,
          children
        }
      )
    }
  ) });
});

export { ColumnLayout, ColumnLayout as default };
//# sourceMappingURL=ColumnLayout.mjs.map
